<template>
  <modal 
  name="datahistorymanagement-modal"
  height="auto"
  width="90%"
  class="customSurveyModal"
  :scrollable="true"
  :adaptive="true"
  :min-width="350"
  @before-open="beforeOpen"
  @closed="closed">
    <div class="row7">
      <div class="inner">
        <header class="modalHeader flex flexAlignS mgReset">
          <p>데이터관리 상세 - 검색이력</p>
          <button @click="onClickCancel"></button>
        </header>
        <div class="flex dataManagement">
          <div class="modalCon">
              <div class="bottom">
                <div class="topContent flex">
                  <div class="left flex">
                    <p>총 <span>{{ productCount + serviceCount }}</span>건</p>
                    <div class="tops">
                        <div class="tabMenu secItemMG">
                            <button class="accountTabBtn" :class="{active: currentTab===0}" v-on:click="setTabChange(0, 'PRODUCT')">
                                제품 <span> {{ productCount }} </span>
                            </button>
                            <button class="accountTabBtn" :class="{active: currentTab===1}" v-on:click="setTabChange(1, 'SERVICE')">
                                서비스 <span> {{ serviceCount }} </span>
                            </button>
                        </div>
                    </div>
                  </div>
                  
                  <div>
                      <input type="text" class="searchInput smSize" v-model="searchText" @keyup.enter="onClickSearch"/>
                      <input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="onClickSearch"/>
                      <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="onClickReset"/>
                  </div>
                </div>
                <div class="tableContainer">
                  <div v-if="currentTab===0" class="sampleTemplate">
                        <b-table
                        ref="dataTable"
                        :fields="fields"
                        :items="getDatas"
                        :per-page="perPage"
                        :current-page="currentPage"
                        hover
                        show-empty
                        empty-text="제품이 존재하지 않습니다.">
                          <template #emptyfiltered="scope">
                            <h4>{{ scope.emptyFilteredText }}</h4>
                          </template>

                        </b-table>

                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalCnt"
                        :per-page="perPage"
                        aria-controls="table">
                        </b-pagination>
                  </div>
                  <div v-else class="sampleTemplate">
                        <b-table
                        ref="serviceTable"
                        :fields="serviceFields"
                        :items="getDatas"
                        :per-page="perPage"
                        :current-page="currentPage"
                        hover
                        show-empty
                        empty-text="서비스가 존재하지 않습니다.">
                          <template #emptyfiltered="scope">
                            <h4>{{ scope.emptyFilteredText }}</h4>
                          </template>

                        </b-table>

                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalCnt"
                          :per-page="perPage"
                          aria-controls="table">
                        </b-pagination>
                  </div>
                </div>
              </div>
          </div>
        </div> 
          
        <div class="modalFooterBtn btnBox addTopPd">
          <button @click="onClickCancel" class="redBtn">확인</button>
        </div>
        
      </div>
    </div>
  </modal>
</template>

<script>
import axios from '@/axios/axios'
import {mapState, mapMutations, mapActions} from 'vuex'
export default {
  name: 'ModalDataHistoryManagement',
  props:[
    'userIdx'
  ],
  data(){
    return{
      productCount: 0,
      serviceCount: 0,
      type : "PRODUCT",
      modalResult: false,
      currentTab: 0,
      searchText: "",
      perPage: 10,
      currentPage: 1,
      totalCnt: 0,
      sortBy: 'IDX',
      sortDesc: false,
			fields: [
				{
					// virtual column
					key: 'ROWNUM',
					label: 'No',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'CATEGORY_NAME',
					label: '구분',
					isActive: false,
					class: 'statusOn text-center'
				},
        {
					// virtual column
					key: 'MANUFACTURE_STR',
					label: '제조구분',
					isActive: false,
					class: 'statusOn text-center'
				},
				{
					key: 'COMPANY',
					label: '업체명',
					class: 'text-center'
				},
				{
					key: 'NAME',
					label: '제품명',
					class: 'text-center'
				},
				{
					key: 'PLACE_NAME',
					label: '사용제안공간',
					class: 'text-center'
				},
				{
					key: 'VIEW_CNT',
					label: '조회수',
					class: 'text-center'
				}
			],
      serviceFields: [
				{
					// virtual column
					key: 'ROWNUM',
					label: 'No',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'CATEGORY_NAME',
					label: '구분',
					isActive: false,
					class: 'statusOn text-center'
				},
        {
					// virtual column
					key: 'LIFE',
					label: '생활구분',
					isActive: false,
					class: 'statusOn text-center'
				},
				{
					key: 'COMPANY',
					label: '업체명',
					class: 'text-center'
				},
				{
					key: 'NAME',
					label: '서비스명',
					class: 'text-center'
				},
				{
					key: 'TARGET',
					label: '사용제안대상',
					class: 'text-center'
				},
				{
					key: 'VIEW_CNT',
					label: '조회수',
					class: 'text-center'
				}
			]
    }
  },
  computed:{
    ...mapState('auth',[
      'user'
    ])
  },
  mounted(){
    this.show()
  },
  methods:{
    ...mapMutations('survey', [
      'resetSurvey'
    ]),
    ...mapActions('survey', [
      'requestDetail',
      'requestSurveyStatics'
    ]),
    show(){
      this.$modal.show('datahistorymanagement-modal')
    },
    hide(){
      this.$modal.hide('datahistorymanagement-modal')
    },
    beforeOpen(){
    },
    onClickSearch(){
      if(this.$refs.dataTable){
        this.$refs.dataTable.refresh();
      }
      if(this.$refs.serviceTable){
        this.$refs.serviceTable.refresh();
      }
    },
    onClickReset(){
      this.searchText = "";
      this.onClickSearch();
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    onClickCancel(){
      this.hide() 
    },
    setTabChange(currentTab, type){
        this.currentTab = currentTab;
        this.type = type;

        if(this.$refs.dataTable){
          this.$refs.dataTable.refresh();
        }
        if(this.$refs.serviceTable){
          this.$refs.serviceTable.refresh();
        }
    },
    getDatas(){
      return axios
          .post('/api/admin/searchHistry/getList', null,  { params: {
              currentPage: this.currentPage,
              perPage: this.perPage,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
              searchText : this.searchText,
              type : this.type,
              userIdx : this.userIdx
          }})
          .then(response => {
              const items = response.data.items;
              this.totalCnt = response.data.totalCnt;
              this.productCount = response.data.productCount;
              this.serviceCount = response.data.serviceCount;
              
              return items;
          })
          .catch(error => {
              console.log("error: "+error)
              return []
          })
    }
  }
}
</script>

<style scoped>
.secItemMG button.accountTabBtn {
    margin: 0 0 0 10px;
}
</style>

<style scoped lang="scss">
	.sampleTemplate ::v-deep {
		@import "~bootstrap/dist/css/bootstrap.min";
		@import "~bootstrap-vue/dist/bootstrap-vue.min";
	}
</style>